import { FC } from 'react';

export const BoldText: FC = () => null;
